/**
 * @desc 模拟运单已妥投
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.test.testTrackingsResponseHandle.Params, options?: any) {
  return updateResponse(
    http(URL + `/test/testTrackingsResponseHandle`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
